import useNavigate from '@fuse/hooks/useNavigate';
import { Alert, CardContent, CircularProgress, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { openDialog } from '@/@fuse/core/FuseDialog/fuseDialogSlice';
// import NewPassword from '../../(protected)/onboarding/components/modals/NewPassword';
import { useAppDispatch } from '@/store/hooks';
import useUser from '@auth/useUser';
import { handleApiError } from '@/utils/errorHandler';

import { resetEppPassword } from '@/@auth/authApi';
import useAuth from '@/@fuse/core/FuseAuthProvider/useAuth';
import NewPassword from '@/app/(protected)/onboarding/components/modals/NewPassword';
import { TermsPrivacyFooter } from '@/components';
import Landing from '@/components/Landing';
import { getNestedString, useConfig } from '@/utils/useConfig';
import { Helmet } from 'react-helmet';


function VerifyEppReset() {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const type = searchParams.get('type');
  const dispatch = useAppDispatch();
  const user = useUser();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>('');
  const [icon, setIcon] = useState<string>('');
  const { authState } = useAuth();
  const isAuthenticated = authState?.isAuthenticated;
  const { config, loading: _loading, error: _error, refresh: _refresh, isStale: _isStale } = useConfig('auth_pages_config');
  



  let epp_type = '';

  if (type === 'l') {
    epp_type = 'live';
  } else if (type === 'o') {
    epp_type = 'ote';
  }

  const navigate = useNavigate();



  useEffect(() => {
    const resetPassword = async () => {
      try {
        setIsLoading(true);
        const response = await resetEppPassword({ key, epp_type: epp_type }).then(res => res.json());
        setIsLoading(false);

        if (isAuthenticated) {

          navigate('/onboarding');
          dispatch(openDialog({
            children: (
              <NewPassword
                mode={epp_type === 'live' ? 'Live' : 'OT&E'}
                password={response?.password || ''}
                email={user?.data.email}
              />
            )
          }));
        } else {
          setMessage(`An email has been sent to your registered email address with your new EPP ${epp_type.charAt(0).toUpperCase() + epp_type.slice(1)} password. Please check your inbox.`);
          setIcon('success');
        }
        
      } catch (_error) {
        if (isAuthenticated) {
          
          navigate('/onboarding');
          dispatch(openDialog({
            children: (
              <NewPassword
                mode={epp_type === 'live' ? 'Live' : 'OT&E'}
                password={''}
                email={user?.data.email}
                error={`${_error?.data?.detail ? _error.data.detail : ''}`}
              />
            )
          }));
        } else {
          
          setMessage(`Failed to reset EPP password. ${_error?.data?.detail ? _error.data.detail : ''} Please contact support.`);
          setIcon('error')

        }

        setIsLoading(false);
        handleApiError(_error, { messagePrefix: 'Failed to reset your EPP password.' });
      }
    };

    if (key && type) {
      resetPassword();
    } else {
      setIsLoading(false)
      setMessage('Invalid password reset link. Please check the link or contact support.');
      setIcon('error');
    }
  }, [key]);

  return <>
    <Helmet>
        <meta charSet="utf-8" />
        <title>{getNestedString(config, 'verifyEppPassword.metadata.title')}</title>
        <meta
            name="description"
            content={getNestedString(config, 'verifyEppPassword.metadata.description')}
        />
    </Helmet>
  <div className="flex min-w-0 flex-1 flex-col items-center sm:flex-row sm:justify-center md:items-start md:justify-start">
                <Paper className="h-full w-full px-16 py-8 ltr:border-r-1 rtl:border-l-1 sm:h-auto sm:w-auto sm:rounded-xl sm:p-48 sm:shadow md:flex md:h-full md:w-1/2 md:items-center md:justify-end md:rounded-none md:p-64 md:shadow-none">
                    <CardContent className="mx-auto w-full max-w-320 sm:mx-0 sm:w-320 space-y-10">
                        <img
                            className="mx-auto"
                            src={getNestedString(config, 'image')}
                            alt="logo"
                        />

                        <h1 className="text-4xl font-semibold leading-tight tracking-tight">
                            EPP {epp_type.charAt(0).toUpperCase() + epp_type.slice(1)} Password Reset
                        </h1>

                        {isLoading ?
                          <div className="flex flex-col justify-center items-center space-y-24">
                            <CircularProgress />
                            <p className='text-primary'>Resetting your {epp_type.charAt(0).toUpperCase() + epp_type.slice(1)} EPP password</p>
                          </div>
                        : <>
                            <Alert severity={icon === 'error' ? 'error' : 'success'}>{message}</Alert>

                          </>}

                        <div className="flex flex-col items-end ">
                            <Link
                                className="text-md font-medium"
                                to="/sign-in"
                            >
                                Contact Support
                            </Link>
                            <Link
                                className="text-md font-medium"
                                to="/sign-in"
                            >
                                Go back to sign in
                            </Link>
                        </div>

                        <TermsPrivacyFooter shortName={getNestedString(config, 'shortName')} />

                    </CardContent>
                </Paper>
                <Landing
                    title={getNestedString(config, 'landingTitle')}
                    description={getNestedString(config, 'verifyEppPassword.landingDescription')}
                />
            </div>
  
  </>;
}

export default VerifyEppReset;
